import React, { useState } from "react";
import { informationService } from "../../api/getInformationService";

export default function Banner() {
    const [apiResponse, setApiResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleButtonClick = async () => {
        setLoading(true);
        setError(null);

        try {
            const apiUrl = await informationService.GetApiUrl();
            console.log('API URL:', apiUrl?.ApiUrl);
            const data = apiUrl?.ApiUrl;
            const corsTest = await informationService.TestCoros();
            console.log('CORS Test Response:', corsTest);

            setApiResponse(data);

        } catch (error) {
            console.error('Error fetching API on button click:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="position-relative" style={{ minHeight: "84vh" }}>
                <div className="position-absolute w-100 h-100">
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                    >
                        <source src="/assets/videos/MidamasHomeVideo.mp4" type="video/mp4" />
                    </video>
                </div>

                <div className="video-overlay"></div>

                <div className="video-banner-text fs-1 text-center">
                    <div data-aos="fade-up">
                        <h1>We manufacture India’s finest lab-grown diamond jewellery.</h1>
                        <h2>Designed and crafted for modern retail.</h2>
                    </div>
                </div>
            </section>

            <section className="text-center ">
                <div className="container">
                    {/*<h1 className="fw-bold mb-3 text-primary">*/}
                    {/*    We Manufacture India’s finest lab-grown diamond jewellery.*/}
                    {/*</h1>*/}
                    {/*<h1 className="fw-bold text-primary">*/}
                    {/*    Designed and crafted for modern retail.*/}
                    {/*</h1>*/}

                    <button className="btn btn-primary mt-4 d-none" onClick={handleButtonClick} disabled={loading}>
                        {loading ? 'Loading...' : 'Fetch API Data'}
                    </button>
                    {error && <p className="text-danger">{error}</p>}
                    {apiResponse && <pre>{JSON.stringify(apiResponse, null, 2)}</pre>}
                </div>
            </section>
        </>
    );
}